export const editCustomSpreadsheetModalQueryKeys = {
  all: ['EditCustomSpreadsheetModal'] as const,
  spreadsheets: (publicationId: string) =>
    [...editCustomSpreadsheetModalQueryKeys.all, 'spreadsheets', publicationId] as const,
  namedRanges: (spreadsheetId: string) =>
    [...editCustomSpreadsheetModalQueryKeys.all, 'namedRanges', spreadsheetId] as const,
  storyContentSpreadsheetReferences: (storyContentId: string) =>
    [...editCustomSpreadsheetModalQueryKeys.all, 'storyContentSpreadsheetReferences', storyContentId] as const
};
